import gql from "graphql-tag";

const contractBuildingMutations = {


    createContractBuilding: gql`
        mutation CreateContractBuilding($contract_id: Int, $building_id: Int, $notice: String, $created_at: DateTime, $updated_at: DateTime) {
            createContractBuilding(contract_id: $contract_id, building_id: $building_id, notice: $notice, created_at: $created_at, updated_at: $updated_at) {
                id,
                contract_id,
                building_id,
                notice,
                created_at,
                updated_at
            }
        }
    `,
    updateContractBuilding: gql`
        mutation UpdateContractBuilding($id: ID!, $contract_id: Int, $building_id: Int, $notice: String, $created_at: DateTime, $updated_at: DateTime) {
            updateContractBuilding(id: $id, contract_id: $contract_id, building_id: $building_id, notice: $notice, created_at: $created_at, updated_at: $updated_at) {
                id,
                contract_id,
                building_id,
                notice,
                created_at,
                updated_at
            }
        }
    `,
};

export default contractBuildingMutations;